export const SUBSCRIPTION_FEE_JOD = 2.5;
export const MPGS_PENDING_SUBSCRIPTION_KEY = 'mpgsPendingSubscription';

export type PendingSubscriptionCheckout = {
  fee: number;
  subscriptionType: 'premium';
};

export function writePendingSubscriptionCheckout(data: PendingSubscriptionCheckout) {
  sessionStorage.setItem(MPGS_PENDING_SUBSCRIPTION_KEY, JSON.stringify(data));
}

export function readPendingSubscriptionCheckout(): PendingSubscriptionCheckout | null {
  try {
    const raw = sessionStorage.getItem(MPGS_PENDING_SUBSCRIPTION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingSubscriptionCheckout;
    if (!parsed || Number(parsed.fee) <= 0) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingSubscriptionCheckout() {
  sessionStorage.removeItem(MPGS_PENDING_SUBSCRIPTION_KEY);
}

export function hasPendingSubscriptionCheckout(): boolean {
  return Boolean(readPendingSubscriptionCheckout());
}
